import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { _getStorage } from "src/app/utils/local-storage";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";
import { errMsg, sccMsg } from "../seller-add/seller-add.const";
export interface Fruit {
  numbers: string;
}
export interface Faxs {
  numbers: string;
}

@Component({
  selector: "app-seller-add",
  templateUrl: "./seller-add.component.html",
  styleUrls: ["./seller-add.component.scss"],
})
export class SellerAddComponent implements OnInit {
  public text_addr: any = {};
  public text_btn: any = {};
  data = {
    seller_id: "",
    seller_tax_id: "",
    seller_branch_id: "",
    seller_name: "",
    seller_branch_name: "",
    seller_storeid: "",
    bu: "",
    branch: "",
    source_system: "",
    seller_status: "active",
    created_time: "",
    building_no: "",
    building_name: "",
    house_no: "",
    village_no: "",
    room_no: "",
    floor: "",
    lane: "",
    road: "",
    sub_district: "",
    district: "",
    province: "",
    postcode: "",
    phone: "",
    email: "",
    buyer_id: "",
    address_status: "",
    addr_agree_tmp: "",
    user_id: "",
  };
  phone1 = "";
  phone2 = "";
  phone3 = "";
  phone4 = "";
  phone5 = "";
  phone6 = "";

  seller_branch = "";
  seller_type = "1";
  fruits: Fruit[] = [];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  sub_district = "";
  province = "";
  district = "";
  phone: any = "";
  email = "";
  address_status = "1";
  buyer_type = "";
  selectedDevice = "";

  showInpBranch = true;
  showbranch2 = true;

  showbtn1 = true;
  showbtn2 = false;
  buyer_tax_id1 = "";
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  public searchTerm: string = "";
  template_lang: any = "TH";
  window: any;
  dataphone: any = [];

  showbtn = true;
  btnback = true;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  @ViewChild("inputBranchStoreId", { static: false })
  inputBranchStoreId;

  constructor(
    private appService: AppService,
    private apiservice: ApiserviceService,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.text_addr = ADDRESS;
    this.text_btn = BTN;
  }

  ngOnInit() {
    this.isFindAddress = false;
    this.groupAddress = this.appService.address_thai;
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.data.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.data.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }

  checkpostcode(e) {
    this.data.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  async refresh() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please refresh...",
    });
    await loading.present();
    window.location.reload();
  }

  // ionViewWillLeave(){
  //   this.appService.setActive(3);
  // }

  goBack() {
    this.router.navigate(["/seller-data"]);
  }
  checkTaxInvoiceInput(e) {
    this.data.seller_tax_id = e.target.value.match(/[0-9]*/);
  }

  checkbranch(e) {
    return e.target.value.match(/[0-9]*/);
    // this.data.seller_branch_id = this.seller_branch;
  }
  formatPhoneNumber(e) {
    let formattedNumber = "";
    let data: any = [];
    let phoneNumberString = e.target.value.match(/[0-9]*/)[0];
    let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{2})(\d{7})(\d{2})$/);
    if (match) {
      formattedNumber = "+" + match[1] + "-" + match[2] + "-" + match[3];
    }
    formattedNumber = null;
  }

  datasave: any = [];
  async savedata() {
    let isConfirm: boolean = false;
    let province: any = this.province;
    let district: any = this.district;
    let sub_district: any = this.sub_district;

    let seller_tax_id = String(this.data.seller_tax_id);

    let phones = [];
    let fax_list = [];

    phones[0] =
      this.phone1 != ""
        ? "+" +
          this.phone1 +
          (this.phone2 != ""
            ? "-" + this.phone2 + (this.phone3 != "" ? "-" + this.phone3 : "")
            : "")
        : "";
    phones[1] =
      this.phone4 != ""
        ? "+" +
          this.phone4 +
          (this.phone5 != ""
            ? "-" + this.phone5 + (this.phone6 != "" ? "-" + this.phone6 : "")
            : "")
        : "";

    for (let f of this.faxs) {
      fax_list.push(f.numbers);
    }

    if (!isConfirm) {
      let filterPostcode = this.groupAddress.filter(
        (f) => f.zipcode === Number(this.data.postcode)
      );
      let filterProvince = this.groupAddress.filter(
        (f) => f.province === this.province
      );

      if (this.data.seller_name === "") {
        this.addSelAlert(errMsg.reqSelName);
      } else if (seller_tax_id.length != 13) {
        this.addSelAlert(errMsg.reqTaxId);
      } else if (!this.appService.checkIdentityCardNumber(seller_tax_id)) {
        this.addSelAlert(errMsg.reqSelTaxId);
      } else if (this.data.bu === "") {
        this.addSelAlert(errMsg.bu);
      } else if (this.data.seller_storeid === "") {
        this.addSelAlert(errMsg.seller_storeid);
      } else if (this.data.seller_branch_id === "") {
        this.addSelAlert(errMsg.seller_branch_id);
      } else if (this.data.branch === "") {
        this.addSelAlert(errMsg.branch);
      } else if (this.data.house_no === "") {
        this.addSelAlert(errMsg.reqHouseNo);
      } else if (this.data.postcode === "") {
        this.addSelAlert(errMsg.reqPostcode);
      } else if (this.data.postcode !== "" && filterPostcode.length === 0) {
        this.addSelAlert(errMsg.notPostcode);
      } else if (province === "") {
        this.addSelAlert(errMsg.reqProv);
      } else if (province !== "" && filterProvince.length === 0) {
        this.addSelAlert(errMsg.notProv);
      } else if (district === "") {
        this.addSelAlert(errMsg.reqDistrict);
      } else if (sub_district === "") {
        this.addSelAlert(errMsg.reqSubDistrict);
      } else if (this.phone1 != "" || this.phone2 != "") {
        if (
          String(this.phone1).length !== 2 &&
          String(this.phone1).length !== 3
        ) {
          this.addSelAlert(errMsg.phone1);
        } else if (
          String(this.phone2).length < 6 ||
          String(this.phone2).length > 10
        ) {
          this.addSelAlert(errMsg.phone2);
        } else if (this.phone4 != "" || this.phone5 != "") {
          if (
            String(this.phone4).length !== 2 &&
            String(this.phone4).length !== 3
          ) {
            this.addSelAlert(errMsg.phone1);
          } else if (
            String(this.phone5).length < 6 ||
            String(this.phone5).length > 10
          ) {
            this.addSelAlert(errMsg.phone2);
          } else {
            isConfirm = true;
          }
        } else {
          isConfirm = true;
        }
      } else if (this.phone4 != "" || this.phone5 != "") {
        if (
          String(this.phone4).length !== 2 &&
          String(this.phone4).length !== 3
        ) {
          this.addSelAlert(errMsg.phone1);
        } else if (
          String(this.phone5).length < 6 ||
          String(this.phone5).length > 10
        ) {
          this.addSelAlert(errMsg.phone2);
        } else {
          isConfirm = true;
        }
      } else if (this.data.source_system == "") {
        this.addSelAlert(errMsg.source_system);
      } else {
        isConfirm = true;
      }
    }

    if (isConfirm) {
      let seller_branch_id = this.data.seller_branch_id[0].padStart(5, "0");
      const data = {
        newSellerData: {
          seller_id: "",
          seller_tax_id: seller_tax_id,
          seller_branch_id: seller_branch_id,
          seller_name: this.data.seller_name,
          seller_branch_name: this.data.seller_branch_name,
          bu: this.data.bu,
          branch: this.data.branch,
          source_system: this.data.source_system,
          userid: this.userID,
          seller_storeid: this.data.seller_storeid,
          seller_status: this.data.seller_status,
          address_detail: {
            addr_id: "",
            building_no: this.data.building_no,
            building_name: this.data.building_name,
            house_no: this.data.house_no,
            room_no: this.data.room_no,
            floor: this.data.floor,
            village_no: this.data.village_no,
            lane: this.data.lane,
            road: this.data.road,
            sub_district: this.sub_district,
            district: this.district,
            province: this.province,
            postcode: String(this.data.postcode),
            phone: phones.join(""),
            fax: fax_list.join(","),
            email: this.data.email,
            address_status: this.data.address_status,
            buyer_id: "",
            seller_id: "",
            addr_agree_tmp: "Y",
            user_id: this.userID,
          },
        },
      };
      console.log("[POST] EDITSELLER data ===::", data);
      try {
        this.apiservice
          ._post(this.apiservice.apiUrl + this.apiservice.editSeller, data)
          .then(async (res: any) => {
            if (res.statusCode === 200) {
              this.showbtn = false;
              this.btnback = true;
              this.addSelAlert(sccMsg.updateScc);
            } else {
              this.addSelAlert(res.statusMessage);
            }
          });
      } catch (error) {
        // this.addSelAlert(errMsg.error);
      }
    }
  }
  checkphone1(e) {
    this.phone1 = e.target.value.match(/[0-9-]*/);
  }
  checkphone2(e) {
    this.phone2 = e.target.value.match(/[0-9-]*/);
  }
  checkphone3(e) {
    this.phone3 = e.target.value.match(/[0-9-]*/);
  }
  checkphone4(e) {
    this.phone4 = e.target.value.match(/[0-9-]*/);
  }
  checkphone5(e) {
    this.phone5 = e.target.value.match(/[0-9-]*/);
  }
  checkphone6(e) {
    this.phone6 = e.target.value.match(/[0-9-]*/);
  }
  seller_fax: any = "";
  checkfaxs(e) {
    this.seller_fax = e.target.value.match(/[0-9-]*/)[0];
  }

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.fruits.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  visiblefaxs = true;
  selectablefaxs = true;
  removablefaxs = true;
  addOnBlurfaxs = true;
  faxs: any = [];
  readonly separatorKeysCodesfaxs: number[] = [ENTER, COMMA];

  addfaxs(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.faxs.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  removefaxs(fax: Faxs): void {
    const index = this.faxs.indexOf(fax);

    if (index >= 0) {
      this.faxs.splice(index, 1);
    }
  }

  async addSelAlert(alrtMsg) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: alrtMsg,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {},
        },
      ],
    });
    alert.present();
  }
  checkemail(e) {
    this.data.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/);
  }
  checkbranchid(e) {
    this.data.seller_branch_id = e.target.value.match(/[0-9]*/);
  }

  checkbranchstoreid(e) {
    setTimeout(() => {
      const validatedValue = this.validateInput(e);
      this.data.seller_storeid = validatedValue;
    }, 10);
  }

  onChangeBranchStoreId(value) {
    let regexp = /^[A-Za-z0-9]+$/;
    if (!value) {
      this.data.seller_storeid = "";
    }
    if (!regexp.test(value)) {
      this.inputBranchStoreId.value = value.replace(/[^A-Za-z0-9]/g, "");
    } else {
      this.data.seller_storeid = value;
    }
  }

  validateInput(input) {
    const regex = /^[A-Za-z0-9]+$/;
    if (!regex.test(input)) {
      return input.replace(/[^A-Za-z0-9]/g, "");
    }
    return input;
  }

  ionViewDidEnter() {
    var showprovince = document.getElementById("showSelectProvince");
    var notshowprovince = document.getElementById("notshowselectProvince");

    if (showprovince !== null) {
      showprovince.style.display = "none";
      notshowprovince.style.display = "none";
    }
    this.appService.setActive(2);
    this.data = {
      seller_id: "",
      seller_tax_id: "",
      seller_branch_id: "",
      seller_name: "",
      seller_branch_name: "",
      seller_storeid: "",
      bu: "",
      branch: "",
      source_system: "",
      seller_status: "active",
      created_time: "",
      building_no: "",
      building_name: "",
      house_no: "",
      village_no: "",
      room_no: "",
      floor: "",
      lane: "",
      road: "",
      sub_district: "",
      district: "",
      province: "",
      postcode: "",
      phone: "",
      email: "",
      buyer_id: "",
      address_status: "",
      addr_agree_tmp: "",
      user_id: "",
    };
    this.seller_branch = "";
    this.seller_type = "1";
    this.fruits = [];

    this.visible = true;
    this.selectable = true;
    this.removable = true;
    this.addOnBlur = true;

    this.sub_district = "";
    this.province = "";
    this.district = "";
    this.phone = "";
    this.email = "";
    this.address_status = "1";
    this.buyer_type = "";
    this.selectedDevice = "";

    this.showInpBranch = true;
    this.showbranch2 = true;
    this.showbtn1 = true;
    this.showbtn2 = false;
    this.buyer_tax_id1 = "";
    this.searchTerm = "";
    this.template_lang = "TH";
    this.window = "";
    this.dataphone = [];

    this.showbtn = true;
    this.btnback = true;
  }
}
